import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaArrowRight,
  FaFileContract,
  FaFileSignature,
  FaBalanceScale,
} from "react-icons/fa";
import logo from "../assets/logo.jpg";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
// import estamp from "../assets/e-stamp-3.jpg";
import img from "../assets/page1.jpg";
import img1 from "../assets/page3.jpg";
import img2 from "../assets/page5.jpg";
// import img3 from "../assets/img3.jpeg";
// import img4 from "../assets/img4.jpeg";
import img5 from "../assets/page2.jpg";
import img6 from "../assets/page4.jpg";
// import img7 from "../assets/img7.jpg";

/* ─── Google Fonts Injection ─── */
const FontLoader = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=DM+Sans:wght@300;400;500;600&display=swap";
    document.head.appendChild(link);
  }, []);
  return null;
};

/* ─── Global typography styles ─── */
const typographyStyle = `
  .charethri-root {
    font-family: 'DM Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  .font-display {
    font-family: 'Cormorant Garamond', serif;
    letter-spacing: -0.01em;
  }
  .font-body {
    font-family: 'DM Sans', sans-serif;
  }
`;

/* ============================= */
/* 🔥 BACKGROUND PARTICLES       */
/* ============================= */
function BackgroundParticles() {
  const particles = Array.from({ length: 40 });
  return (
    <div className="absolute w-full inset-0 overflow-hidden z-0 pointer-events-none">
      {particles.map((_, i) => {
        const size = Math.random() * 6 + 2;
        const left = Math.random() * 100;
        const duration = Math.random() * 20 + 15;
        const delay = Math.random() * 5;
        return (
          <motion.span
            key={i}
            className="absolute bg-[#add3f7] rounded-full opacity-80"
            style={{ width: size, height: size, left: `${left}%`, bottom: "0" }}
            animate={{ y: "-1210vh", opacity: [0, 1, 1, 0] }}
            transition={{ duration, delay, repeat: Infinity, ease: "linear" }}
          />
        );
      })}
    </div>
  );
}

/* ─── Description renderer ─── */
function CardDescription({ text }) {
  const lines = text
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);

  return (
    <ul
      className="mt-5 space-y-2.5 font-body"
      style={{ listStyle: "none", padding: 0, margin: 0 }}
    >
      {lines.map((line, i) => {
        const isBullet = line.startsWith("•");
        const clean = line.replace(/^•\s*/, "");
        return (
          <li
            key={i}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: isBullet ? "10px" : "0",
              fontSize: "clamp(0.88rem, 1.5vw, 1rem)",
              lineHeight: "1.7",
              color: "#4B5563",
              fontWeight: isBullet ? 400 : 500,
            }}
          >
            {isBullet && (
              <span
                style={{
                  marginTop: "6px",
                  width: "6px",
                  height: "6px",
                  borderRadius: "50%",
                  background: "#6B7280",
                  flexShrink: 0,
                  display: "inline-block",
                }}
              />
            )}
            <span>{clean}</span>
          </li>
        );
      })}
    </ul>
  );
}

const sliderServices = [
  {
    icon: <FaFileSignature size={36} />,
    title: "CHARETHRI BUSINESS SOLUTIONS",
    subheading: "(29 Years of Trust. Clarity. Commitment.)",
    subtitle: "29 Years of Trust. Clarity. Commitment.",
    description: `We have stood as a steady guide in legal documentation and property registration. This is not just a service firm—it is a long-standing institution built on consistency and credibility.

We have protected what matters most—your property, your business, your compliance, and your peace of mind.

From pre-registration to post-registration. Fast-track your property registration with zero stress.

We simplify complex documentation.
Clear process. Proper execution
Precision in every detail
`,
    url: "https://charethribs.com",
    bg: "bg-[#6B9080]",
    img: img,
  },
  {
    icon: <FaFileContract size={36} />,
    title: "Pre-Registration",
    heading: "Your property, our priority. Legally Sound, Start to Finish",
    description: `Get your paperwork right before you sign.

• Legal Check: Title verification & due diligence
• EC Verification: Ensuring a clear history
• Expert Drafting: Sale Deeds & Agreements made easy
• Cost Guidance: Clear advice on stamp duty & fees`,
    url: "https://charethribs.com",
    bg: "bg-[#5E548E]",
    img: img5,
  },
  {
    icon: <FaFileSignature size={36} />,
    title: "Property Registration",
    heading:
      "Property registration made simple. We handle the paperwork; you get the keys.",
    description: `We handle the paperwork; you enjoy your new home.

• Seamless Filing: Sale, Gift, Partition & Release Deeds
• Legal Support: GPA / POA drafting and registration
• On-Site Coordination: Sub-Registrar office visits managed by us
• End-to-End Support: We're with you until the final signature`,
    url: "https://charethribs.com",
    bg: "bg-[#3A5A40]",
    img: img1,
  },
  {
    icon: <FaBalanceScale size={36} />,
    title: "Post-Registration",
    heading: "Expert Guidance for Every Step of Your Property Journey",
    description: `We finish the job after registration is done.

• Khata Services: Transfer & bifurcation
• Mutation Support: Updating official records
• Liaison Support: BBMP & Panchayat follow-ups
• Tax & Documentation: Property tax guidance & final filing`,
    url: "https://charethribs.com",
    bg: "bg-[#355070]",
    img: img6,
  },
  {
    icon: <FaPhoneAlt size={36} />,
    title: "Request a Callback",
    subtitle: "Our experts are ready to handle the paperwork for you.",
    description: `Reach out today for a consultation.

WhatsApp / Call: 9832444111
Email: contact@charethribs.com
Website: www.charethribs.com
Location: Koramangala (Google Map Link Available Below)`,
    url: "#",
    bg: "bg-[#2F3E46]",
    img: img2,
    isForm: true,
  },
];

export default function StackedSlider() {
  const [isMobile, setIsMobile] = useState(false);
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .sendForm(
        "service_qwrb63k",
        "template_fqp4ecl",
        formRef.current,
        "dVsOb6uc-37lpSSqA"
      )
      .then(() => {
        setLoading(false);
        setSuccess(true);
        formRef.current.reset();
        setTimeout(() => setSuccess(false), 2000);
      });
  };

  return (
    <>
      <FontLoader />
      <style>{typographyStyle}</style>

      <div className="charethri-root relative w-full flex items-center justify-center bg-white overflow-auto md:overflow-hidden px-4 sm:px-6 lg:px-10 py-8 sm:py-10 pb-20 md:pb-10">
        <BackgroundParticles />

    {/* LOGO + COMPANY NAME */}
<a
  href="https://charethribs.com/"
  target="_blank"
  rel="noopener noreferrer"
  className="absolute top-4 left-4 z-20 flex items-center gap-3"
>
  <img
    src={logo}
    alt="Charethri Business Solutions"
    className="h-10 sm:h-12 md:h-14 object-contain"
  />

  <span
    className="font-display text-xl"
    style={{
      fontSize: "clamp(0.9rem, 1.5vw, 1.2rem)",
      fontWeight: 900,
      color: "#111827",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
    }}
  >
    CHARETHRI BUSINESS SOLUTIONS
  </span>
</a>

        <div className="md:mt-12 mt-12 relative w-full max-w-[1200px] min-h-[480px] sm:min-h-[600px] md:min-h-[650px] md:flex items-center justify-center">
          <div className="flex flex-col gap-8 w-full">
            {sliderServices.map((card, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="w-full rounded-[28px] bg-white/70 backdrop-blur-2xl border border-black/40 overflow-hidden"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 text-gray-800">
                  {/* ── Image Side ── */}
                  <div className="relative overflow-hidden h-[220px] sm:h-[520px] md:h-[550px]">
                    <img
                      src={card.img}
                      alt={card.title}
                      loading="lazy"
                      className="w-full h-full object-contain"
                    />

                    <div className="hidden md:flex absolute bottom-12 left-4 flex-wrap gap-3">
                      <a
                        href="tel:+919832444111"
                        className="border border-black backdrop-blur-md text-black px-6 py-2 text-xs md:text-sm rounded-full flex items-center gap-2 font-semibold hover:scale-105 transition font-body"
                      >
                        <FaPhoneAlt size={12} />
                        Call
                      </a>
                      <a
                        href="https://wa.me/919832444111"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-green-500 text-white px-4 py-2 text-xs md:text-sm rounded-full flex items-center gap-2 font-semibold hover:scale-105 transition font-body"
                      >
                        <FaWhatsapp />
                        WhatsApp
                      </a>
                      <a
                        href={card.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="border border-black backdrop-blur-md text-black px-4 py-2 text-xs md:text-sm text-nowrap rounded-full flex items-center gap-2 font-semibold hover:gap-3 transition-all font-body"
                      >
                        Read More <FaArrowRight />
                      </a>
                    </div>
                  </div>

                  {/* ── Content Side ── */}
                  <div className="p-6 sm:p-10 md:p-12 flex flex-col justify-between">
                    <div>
                      {/* Sub-heading (above title) */}
                      {card.heading && (
                        <p
                          className="font-body"
                          style={{
                            fontSize: "clamp(0.78rem, 1.3vw, 0.9rem)",
                            fontWeight: 500,
                            color: "#6B7280",
                            letterSpacing: "0.03em",
                            textTransform: "uppercase",
                            marginBottom: "10px",
                            lineHeight: 1.5,
                          }}
                        >
                          {card.heading}
                        </p>
                      )}

                      {/* Main Title */}
                      <h2
                        className="font-display"
                        style={{
                          fontSize: "clamp(1.6rem, 3.5vw, 2.6rem)",
                          fontWeight: 700,
                          lineHeight: 1.15,
                          letterSpacing: "-0.02em",
                          color: "#111827",
                          marginBottom: card.subheading ? "6px" : "0",
                        }}
                      >
                        {card.title}
                      </h2>

                      {/* Tagline below title */}
                      {card.subheading && (
                        <p
                          className="font-body"
                          style={{
                            fontSize: "clamp(0.8rem, 1.4vw, 0.95rem)",
                            fontWeight: 400,
                            color: "#9CA3AF",
                            letterSpacing: "0.015em",
                            marginTop: "4px",
                            lineHeight: 1.6,
                          }}
                        >
                          {card.subheading}
                        </p>
                      )}

                      {/* Divider */}
                      <div
                        style={{
                          width: "48px",
                          height: "2px",
                          background: "#D1D5DB",
                          margin: "18px 0",
                          borderRadius: "2px",
                        }}
                      />

                      {/* Form or Description */}
                      {card.isForm ? (
                        <form
                          ref={formRef}
                          onSubmit={sendEmail}
                          className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-2xl font-body"
                        >
                          <div className="relative">
                            <input
                              type="text"
                              name="from_name"
                              required
                              placeholder=" "
                              className="peer w-full px-4 pt-5 pb-2 rounded-xl bg-white/80 border border-gray-300 text-gray-800 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition"
                              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.95rem" }}
                            />
                            <label
                              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.82rem", letterSpacing: "0.02em" }}
                              className="absolute left-4 top-2 text-gray-500 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-sm peer-focus:text-indigo-600 transition-all"
                            >
                              Name
                            </label>
                          </div>

                          <div className="relative">
                            <input
                              type="tel"
                              name="phone"
                              required
                              placeholder=" "
                              className="peer w-full px-4 pt-5 pb-2 rounded-xl bg-white/80 border border-gray-300 text-gray-800 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition"
                              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.95rem" }}
                            />
                            <label
                              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.82rem", letterSpacing: "0.02em" }}
                              className="absolute left-4 top-2 text-gray-500 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-sm peer-focus:text-indigo-600 transition-all"
                            >
                              Phone
                            </label>
                          </div>

                          <div>
                            <select
                              name="service"
                              required
                              className="w-full px-4 py-3 rounded-xl bg-white/80 border border-gray-300 text-gray-800 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition"
                              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.95rem" }}
                            >
                              <option value="">Select Service Needed</option>
                              <option value="Pre-Registration">Pre-Registration</option>
                              <option value="Registration">Registration</option>
                              <option value="Post-Registration">Post-Registration</option>
                            </select>
                          </div>

                          <div>
                            <select
                              name="location"
                              required
                              className="w-full px-4 py-3 rounded-xl bg-white/80 border border-gray-300 text-gray-800 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition"
                              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.95rem" }}
                            >
                              <option value="">Select Property Location</option>
                              <option value="Bangalore-North">Bangalore-North</option>
                              <option value="Bangalore-South">Bangalore-South</option>
                              <option value="Bangalore-East">Bangalore-East</option>
                              <option value="Others">Others</option>
                            </select>
                          </div>

                          <div className="relative md:col-span-2">
                            <textarea
                              name="message"
                              rows="4"
                              required
                              placeholder=" "
                              className="peer w-full px-4 pt-6 pb-3 rounded-xl bg-white/80 border border-gray-300 text-gray-800 outline-none resize-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition"
                              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.95rem" }}
                            />
                            <label
                              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.82rem", letterSpacing: "0.02em" }}
                              className="absolute left-4 top-3 text-gray-500 peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:top-3 peer-focus:text-sm peer-focus:text-indigo-600 transition-all"
                            >
                              Message
                            </label>
                          </div>

                          <div className="md:col-span-2">
                            <button
                              type="submit"
                              disabled={loading}
                              className="w-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white py-3 rounded-xl hover:scale-105 hover:shadow-lg transition-all duration-300"
                              style={{
                                fontFamily: "'DM Sans', sans-serif",
                                fontWeight: 600,
                                fontSize: "0.95rem",
                                letterSpacing: "0.03em",
                              }}
                            >
                              {loading ? "Sending…" : "Submit Request"}
                            </button>
                          </div>
                        </form>
                      ) : (
                        <CardDescription text={card.description} />
                      )}
                    </div>

                    {/* ── Social + Phone Row ── */}
                    <div className="flex flex-col gap-4 mt-6 sm:flex-row justify-center items-center sm:items-center sm:justify-between">
                      <div className="hidden md:flex gap-5">
                        <a
                          href="https://wa.me/919832444111"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:scale-110 transition-transform"
                        >
                          <FaWhatsapp size={22} />
                        </a>
                        <FaFacebookF size={20} />
                        <FaInstagram size={20} />
                        <FaLinkedinIn size={20} />
                      </div>

                      <a
                        href="tel:+919832444111"
                        className="inline-flex items-center justify-center gap-2 bg-white/15 px-4 py-2 rounded-full hover:bg-white/25 transition font-body"
                        style={{
                          fontSize: "0.88rem",
                          fontWeight: 500,
                          letterSpacing: "0.02em",
                        }}
                      >
                        <FaPhoneAlt />
                        <span>+91 98324 44111</span>
                      </a>

                      {/* Mobile Fixed Bottom Bar */}
                      <div className="fixed bottom-0 left-0 w-full bg-white shadow-lg border-t border-gray-200 flex justify-around items-center py-3 px-4 md:hidden z-50">
                        <a
                          href="tel:+919832444111"
                          className="flex flex-col items-center font-body"
                          style={{ fontSize: "0.72rem", fontWeight: 600, color: "#374151" }}
                        >
                          <FaPhoneAlt size={18} />
                          Call
                        </a>
                        <a
                          href="https://wa.me/919832444111"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex flex-col items-center font-body"
                          style={{ fontSize: "0.72rem", fontWeight: 600, color: "#16a34a" }}
                        >
                          <FaWhatsapp size={20} />
                          WhatsApp
                        </a>
                        <a
                          href="https://charethribs.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex flex-col items-center font-body"
                          style={{ fontSize: "0.72rem", fontWeight: 600, color: "#374151" }}
                        >
                          <FaArrowRight size={18} />
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Success Overlay */}
          {success && (
            <div className="fixed inset-0 z-[100] flex items-center justify-center">
              <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />
              <div className="relative bg-white rounded-xl px-8 py-6 shadow-2xl text-center animate-scaleIn">
                <div className="text-green-500 text-4xl mb-3">✔</div>
                <h3
                  className="font-display"
                  style={{ fontSize: "1.2rem", fontWeight: 700, color: "#111827" }}
                >
                  Message Sent Successfully!
                </h3>
                <p
                  className="font-body"
                  style={{ fontSize: "0.88rem", color: "#6B7280", marginTop: "6px" }}
                >
                  We will contact you shortly.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Social + Phone Footer */}
      <div className="md:hidden flex flex-row p-2 mb-5 items-center justify-between font-body">
        <div className="flex gap-5">
          <a
            href="https://wa.me/919832444111"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-transform"
          >
            <FaWhatsapp size={22} />
          </a>
          <FaFacebookF size={20} />
          <FaInstagram size={20} />
          <FaLinkedinIn size={20} />
        </div>
        <a
          href="tel:+919832444111"
          className="inline-flex items-center justify-center gap-2 bg-white/15 px-4 py-2 rounded-full hover:bg-white/25 transition"
          style={{ fontSize: "0.88rem", fontWeight: 500 }}
        >
          <FaPhoneAlt />
          <span>+91 98324 44111</span>
        </a>
      </div>
    </>
  );
}